import { FormikProvider, useFormik } from "formik";
import * as yup from "yup";

import { InputField } from "@vega-core/components/Form/Fields/InputField";
import { ActionaryModal } from "@vega-core/components/Modals/ActionaryModal/ActionaryModal";
import { m } from "@vega-core/paraglide/messages";

export type AddDataRoomModalProps = {
  onClose: () => void;
  onConfirm: (name: string, url: string) => void;
  isUpdatePending?: boolean;
};

type FormValues = {
  name: string;
  url: string;
};

export const AddDataRoomModal = ({
  onClose,
  onConfirm,
  isUpdatePending,
}: AddDataRoomModalProps) => {
  const validationSchema = yup.object({
    name: yup.string().required(m.formValidation_requiredText()),
    url: yup
      .string()
      .required(m.formValidation_requiredText())
      .url(m.formValidation_invalidUrl()),
  });

  const formik = useFormik<FormValues>({
    initialValues: { name: "", url: "" },
    validationSchema,
    onSubmit: (values) => {
      onConfirm(values.name, values.url);
    },
  });

  const handleClose = () => {
    formik.resetForm();
    onClose();
  };

  return (
    <ActionaryModal
      ModalButtonsGroupProps={{
        mainActionText: m.coInvestments_dataRoom_addAction(),
        mainAction: formik.submitForm,
        mainActionVariant: "primary",
        disabled: !formik.isValid || !formik.dirty || isUpdatePending,
        secondaryActionText: m.common_cancel(),
        secondaryAction: handleClose,
        disabledSecondary: isUpdatePending,
      }}
      fluidHeight
      open
      setOpen={onClose}
      title={m.coInvestments_dataRoom_addModal_title()}
    >
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
          <div className="mt-6 w-full md:min-w-96 space-y-4">
            <InputField label={m.common_name()} name="name" withBorder />
            <InputField
              label={m.coInvestments_dataRoom_urlLabel()}
              name="url"
              placeholder="https://dataroom.com"
              type="url"
              withBorder
            />
          </div>
        </form>
      </FormikProvider>
    </ActionaryModal>
  );
};
